export default "__VITE_ASSET__BMQKtWMZ__"